import React from 'react'
import PropTypes from 'prop-types'

import { withTranslation } from '../../translations'
import SubNavContainer from '../../components/navbar/sub_nav_container'
import NavItem from '../../components/navbar/nav_item'

import packageJson from '../../../package.json'
const { version } = packageJson

const Fit3dAdminNav = ({ isQcAdmin, pathname, redirectPage, t }) => (
  <SubNavContainer
    header={t('nav.admin')}
    subheader={`${t('nav.version')} ${version}`}
  >
    <ul
      className="nav-pills flex-md-column list-unstyled"
      style={{ padding: '15px 0px' }}
    >
      {isQcAdmin ? (
        <>
          <NavItem
            isSelected={pathname === '/admin/records'}
            text={t('nav.records')}
            clickHandler={redirectPage('/admin/records')}
          />
          <NavItem
            isSelected={pathname === '/admin/records/snap-failures'}
            text={t('nav.snapFailures')}
            clickHandler={redirectPage('/admin/records/snap-failures')}
          />
          <NavItem
            isSelected={pathname === '/admin/records/qc'}
            text={t('nav.qc')}
            clickHandler={redirectPage('/admin/records/qc')}
          />
        </>
      ) : (
        <>
          <NavItem
            isSelected={pathname === '/admin/records'}
            text={t('nav.records')}
            clickHandler={redirectPage('/admin/records')}
          />
          <NavItem
            isSelected={pathname === '/admin/records/snap-failures'}
            text={t('nav.snapFailures')}
            clickHandler={redirectPage('/admin/records/snap-failures')}
          />
          <NavItem
            isSelected={pathname === '/admin/records/qc'}
            text={t('nav.qc')}
            clickHandler={redirectPage('/admin/records/qc')}
          />
          <NavItem
            isSelected={pathname === '/admin/facilities'}
            text={t('nav.facilities')}
            clickHandler={redirectPage('/admin/facilities')}
          />
          <NavItem
            isSelected={pathname === '/admin/scanners'}
            text={t('nav.scanners')}
            clickHandler={redirectPage('/admin/scanners')}
          />
          <NavItem
            isSelected={pathname === '/admin/coaches'}
            text={t('nav.coaches')}
            clickHandler={redirectPage('/admin/coaches')}
          />
          <NavItem
            isSelected={pathname === '/admin/users'}
            text={t('nav.users')}
            clickHandler={redirectPage('/admin/users')}
          />
        </>
      )}
    </ul>
  </SubNavContainer>
)

Fit3dAdminNav.propTypes = {
  pathname: PropTypes.string.isRequired,
  redirectPage: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

export default withTranslation(Fit3dAdminNav)
